"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _DiscountAmountFooter = _interopRequireDefault(require("./DiscountAmountFooter.proptype"));
var _constant = require("../Button/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var DiscoutAmountFooterWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountAmountFooter__DiscoutAmountFooterWrapper",
  componentId: "sc-1lfcf2d-0"
})(["", " display:flex;flex-direction:row;padding:10px;width:100%;"], function (_ref) {
  var hasTopBorder = _ref.hasTopBorder;
  return hasTopBorder ? "border-top: 1px ".concat(function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.greyLight;
  }, " solid;\n  box-shadow: 0px -3px 0px rgba(0, 0, 0, 0.08);") : '';
});
var SummaryAmount = _styledComponents.default.div.withConfig({
  displayName: "DiscountAmountFooter__SummaryAmount",
  componentId: "sc-1lfcf2d-1"
})(["width:90%;align-self:center;"]);
var ApplyButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "DiscountAmountFooter__ApplyButtonWrapper",
  componentId: "sc-1lfcf2d-2"
})([""]);
var ApplyButton = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "DiscountAmountFooter__ApplyButton",
  componentId: "sc-1lfcf2d-3"
})([""]);
ApplyButton.displayName = 'ApplyButton';
var TotalAmount = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountAmountFooter__TotalAmount",
  componentId: "sc-1lfcf2d-4"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.bold;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight.semiLarge;
}, function (_ref6) {
  var isMobile = _ref6.isMobile,
    theme = _ref6.theme;
  return isMobile ? theme.fontSize.small : theme.fontSize.normal;
});
TotalAmount.displayName = 'TotalAmount';
var TotalAmountMessage = _styledComponents.default.div.withConfig({
  displayName: "DiscountAmountFooter__TotalAmountMessage",
  componentId: "sc-1lfcf2d-5"
})(["font-family:", ";color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily.default;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.greyDark;
});
TotalAmountMessage.displayName = 'TotalAmountMessage';
var InitialAmountStrike = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountAmountFooter__InitialAmountStrike",
  componentId: "sc-1lfcf2d-6"
})(["margin-right:5px;font-family:", ";color:", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontFamily.default;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.greyDark;
});
var SavedAmountText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "DiscountAmountFooter__SavedAmountText",
  componentId: "sc-1lfcf2d-7"
})(["color:", ";font-family:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.tertiary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontFamily.default;
});
var DiscoutAmountFooter = function DiscoutAmountFooter(props) {
  var theme = props.theme,
    translations = props.translations,
    initialAmount = props.initialAmount,
    discountAmount = props.discountAmount,
    currencyCode = props.currencyCode,
    isLoading = props.isLoading,
    onClickApply = props.onClickApply,
    showLoaderWhenClicked = props.showLoaderWhenClicked,
    hasTopBorder = props.hasTopBorder,
    isEnabled = props.isEnabled,
    isMobile = props.isMobile;
  var totalAmount = translations.totalAmount,
    savedDesc = translations.savedDesc;
  var initialAmountFormatted = _utilities.default.formatAmount(initialAmount, 2, currencyCode);
  var discountAmountFormatted = _utilities.default.formatAmount(discountAmount, 2, currencyCode);
  var savedDescMsg = _utilities.default.transformText(savedDesc, [discountAmountFormatted]);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    discountedAmount = _useState2[0],
    setDiscountedAmount = _useState2[1];
  var _useState3 = (0, _react.useState)(isLoading),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    appliedLoading = _useState4[0],
    setAppliedLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    var amountRemaining = initialAmount - discountAmount;
    var discountedAmountFormatted = _utilities.default.formatAmount(amountRemaining, 2, currencyCode);
    setDiscountedAmount(discountedAmountFormatted);
  }, [initialAmount, discountAmount, currencyCode]);
  (0, _react.useEffect)(function () {
    setAppliedLoading(isLoading);
  }, [isLoading]);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var buttonCustomProperties = {
    paddingRight: '57px',
    paddingLeft: '57px'
  };
  var clickApplyHandler = function clickApplyHandler() {
    if (showLoaderWhenClicked) {
      setAppliedLoading(true);
    }
    onClickApply();
  };
  var SavedAmount = function SavedAmount() {
    if (discountAmount === 0) {
      return /*#__PURE__*/_react.default.createElement(TotalAmountMessage, {
        isMobile: isMobile
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: "small"
      }, totalAmount));
    }
    return /*#__PURE__*/_react.default.createElement(TotalAmountMessage, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(InitialAmountStrike, {
      strikethrough: true,
      type: "small"
    }, currencyCode, " ", initialAmountFormatted), /*#__PURE__*/_react.default.createElement(SavedAmountText, {
      type: "small"
    }, savedDescMsg));
  };
  var isMoveTheme = theme === 'AIRASIA_MOVE';
  var buttonThemeOverrides = _constant.MOVE_BUTTON_THEME_OVERRIDES[isMoveTheme ? 'AIRASIA_MOVE' : 'AIRASIA_CLASSIC'].primary[isEnabled];
  var spinnerColor = isMoveTheme ? 'secondary' : 'primaryLight';
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(DiscoutAmountFooterWrapper, {
      hasTopBorder: hasTopBorder
    }, /*#__PURE__*/_react.default.createElement(SummaryAmount, null, /*#__PURE__*/_react.default.createElement(TotalAmount, {
      isMobile: isMobile
    }, currencyCode, " ", discountedAmount), SavedAmount()), /*#__PURE__*/_react.default.createElement(ApplyButtonWrapper, null, /*#__PURE__*/_react.default.createElement(ApplyButton, (0, _extends2.default)({
      customProperties: buttonCustomProperties,
      handleClick: clickApplyHandler,
      disabled: !isEnabled
    }, buttonThemeOverrides), appliedLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      color: spinnerColor,
      height: "18px",
      width: "44px"
    }) : 'Apply')));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
DiscoutAmountFooter.propTypes = _DiscountAmountFooter.default.PropTypes;
DiscoutAmountFooter.defaultProps = _DiscountAmountFooter.default.DefaultProps;
var _default = DiscoutAmountFooter;
exports.default = _default;